export const finance = {
  section: {
    title: 'Finance',
  },
  annualCosts: {
    title: 'Annual company costs',
    description:
      'Recurring costs funded from the company kitty. Enter annual or monthly amounts — monthly figures are multiplied by 12. These are deducted before paid work hours are calculated and are not added to the hours pool.',
    total: 'Annual total {{value}}',
    empty: 'No company costs yet.',
    label: 'Cost name',
    amount: 'Amount £',
    amountAnnual: 'Annual £',
    amountMonthly: 'Monthly £',
    period: 'Period',
    periodAnnual: 'Annual',
    periodMonthly: 'Monthly',
    note: 'Note (optional)',
    add: 'Add cost',
    clear: 'Clear all',
    remove: 'Remove cost',
    perYear: '/yr',
    perMonth: '/mo',
    annualised: '{{monthly}}/mo → {{annual}}/yr',
    statLabel: 'Annual total',
    menuDescription: 'Recurring costs taken from the company kitty',
  },
  success: {
    annualCostsUpdated: 'Annual company costs updated',
  },
};
